import ListItem from '@/components/List/ListItem'
import ListSection from '@/components/List/ListSection'
import NavBar from '@/components/NavBar'
import Page from '@/components/Page'
import ThemeSwitcher from '@/components/ThemeSwitcher'
import { createFileRoute } from '@tanstack/react-router'
import { useTitle } from 'react-use'
import styles from './setting.module.css'

export const Route = createFileRoute('/setting')({
	component: SettingPage,
})

function SettingPage() {
	useTitle(`设置 - 即刻`)

	return (
		<Page header={<NavBar title="设置" />} className={styles.page}>
			<div className={styles.content}>
				<ListSection title="外观">
					<ListItem className={styles.listItem}>
						<div>主题</div>
						<ThemeSwitcher className={styles.themeSwitcher} />
					</ListItem>
				</ListSection>
			</div>
		</Page>
	)
}
